package com.essntl.features.itinerary.ui.itinerary_overview

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.collectSuccessEvent
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class ItineraryOverviewViewModel(
    private val itineraryRepository: ItineraryRepository,
    private val getCurrentUserUseCase: GetCurrentUserUseCase,
    private val state: MutableStateFlow<ItineraryOverviewState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    init {
        getCurrentProfile()
        collectSuccessEvent(
            flow = getCurrentUserUseCase.successEvent,
            getState = { state.value.getCurrentProfile },
            setState = { newState -> state.update { it.copy(getCurrentProfile = newState) } },
        )
    }

    fun onEvent(event: ItineraryOverviewEvent) {
        when (event) {
            is ItineraryOverviewEvent.GetItinerary -> getItinerary(event)
            is ItineraryOverviewEvent.ClearState -> clearState()
        }
    }

    private fun getCurrentProfile() =
        scope.launch {
            getCurrentUserUseCase.get()
        }

    private var getItineraryJob: Job? = null
    private fun getItinerary(event: ItineraryOverviewEvent.GetItinerary) {
        if (state.value.getItinerary.data?.id == event.id) return

        getAllProposalService(event.id)

        getItineraryJob?.cancel()
        getItineraryJob = getData(
            getData = { itineraryRepository.get(event.id) },
            getState = { state.value.getItinerary },
            setState = {
                state.value = state.value.copy(getItinerary = it)
            },
            ignoreLoading = true,
        )
    }

    private var getAllProposalServiceJob: Job? = null
    private fun getAllProposalService(itineraryId: String) {
        getAllProposalServiceJob?.cancel()
        getAllProposalServiceJob = getData(
            getData = { itineraryRepository.getAllItineraryService(itineraryId) },
            getState = { state.value.getAllItineraryService },
            setState = { state.value = state.value.copy(getAllItineraryService = it) },
        )
    }

    private fun clearState() {
        state.value = ItineraryOverviewState(
            getCurrentProfile = state.value.getCurrentProfile,
        )
        getItineraryJob?.cancel()
        getAllProposalServiceJob?.cancel()
    }
}